// import {Footer} from '@common/ui/footer/footer';
// import {MainNavbar} from '@app/main-navbar';
import {ReactNode} from 'react';
import {useScrollToTop} from '@common/ui/navigation/use-scroll-to-top';
// import {AdHost} from '@common/admin/ads/ad-host';

interface Props {
  children: ReactNode;
}
export function SitePageLayout({children}: Props) {
  useScrollToTop();
  return (
    <div className="flex flex-col ">
      {/* <p>Next fleix type hero image</p> */}
      {/* <div className="flex-auto"> */}
      <div className="relative flex min-h-screen  flex-col bg-[#00050D] text-white">
        {/* <MainNavbar /> */}
        <div className="flex-1"> {children}</div>
        {/* <Footer /> */}
      </div>
      {/* </div> */}
    </div>
  );
}
